import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useUserContext } from "../context/UserContext";
import { trackLogfrogPageview } from "../utils/logfrog";

/** Mirrors mobile screen sync by recording Logfrog pageviews on SPA route changes. */
export function LogfrogRouteSync() {
  const { pathname, search } = useLocation();
  const { user } = useUserContext();
  const lastPath = useRef("");

  useEffect(() => {
    const pathKey = `${user?.userId || "guest"}:${pathname}${search}`;
    if (pathKey === lastPath.current) return;
    lastPath.current = pathKey;
    trackLogfrogPageview({
      pathname,
      search,
      isAuthenticated: Boolean(user?.userId),
    });
  }, [pathname, search, user?.userId]);

  return null;
}
